/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable operator-linebreak */
/* eslint-disable quotes */
/* eslint-disable no-shadow */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { ErrorMessage } from '@hookform/error-message';
import SubmitButton from '../components/SubmitButton';
import TooltipDueToday from '../components/Tooltips/TooltipDueToday';
import SidebarCheckout from '../components/SidebarCheckout';
import { LineItemRow } from '../components/CollapsibleLineItems';
import useFirstPayment from '../hooks/useFirstPayment';
import convertToCurrency from '../helpers/convertToCurrency';
import calculatePeriod from '../helpers/calculatePeriod';
import cardUnmask from '../helpers/cardUnMask';
import getUserDeviceData from '../helpers/getUserDeviceData';
import useListenSize from '../hooks/useListenSize';
import useShopifyApi from '../hooks/useShopifyApi';
import useApi from '../hooks/useApi';
import normalizeCardDate from '../helpers/normalizeCardDate';
import normalizeCardNumber from '../helpers/normalizeCardNumber';
import { segmentEvent } from '../helpers/sendEvent';
import { addResolveRedirectUrl, confirmAonAgreement, confirmKplusAgreement } from '../redux/actions';
import { KATAPULT_BOOST_PRICE, isKplusAvailable as checkKplusAvailable } from '../helpers/kplusPricing';
import Card1 from '../assets/img/card1.png';
import Card2 from '../assets/img/card2.png';
import Card3 from '../assets/img/card3.png';
import Card4 from '../assets/img/card4.png';
import Cards from '../assets/img/cards.png';
import Lock from '../assets/img/lock.png';
import InfoIcon from '../assets/img/kplus-info.svg';

const validateDate = value => {
  const [month, year] = value.split('/');
  if (!month || !year) return 'Invalid Date';
  const enteredDate = moment(`${parseInt(year, 10) + 2000}-${month}-1`, 'YYYY-MM-DD');
  if (enteredDate.isValid()) {
    return enteredDate.isAfter() ? true : 'Date needs to be in the future';
  }
  return 'Date needs to be in the future';
};

function Checkout() {
  const {
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    register,
  } = useForm({ mode: 'onChange' });

  const CardExpiration = register('CardExpiration', {
    validate: {
      validateDate,
    },
  });

  const CardNumber = register('CardNumber', {
    required: 'This is required.',
    minLength: 15 + 3, // 3 spaces
  });

  const { request, loading } = useFirstPayment();
  const { request: shopifyRequest, loading: shopifyLoading } = useShopifyApi();
  const { request: apiRequest } = useApi();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [isPaymentFailed, setIsPaymentFailed] = useState(false);
  const [messagePaymentError, setMessagePaymentError] = useState('');
  const [isMobileSidebarVisibe, setMobileSidebarVisibe] = useState(false);
  const [isAonModalOpened, setAonModalOpened] = useState(false);
  const [isProtectionModalOpened, setProtectionModalOpened] = useState(false);
  const [isProtectionDeclined, setIsProtectionDeclined] = useState(false);
  const [kplusUnenrollError, setKplusUnenrollError] = useState('');

  const history = useHistory();
  const dispatch = useDispatch();
  useListenSize();

  const store = useSelector(state => ({
    checkoutUid: state.loanInfo?.checkoutUid,
    dueToday: state.loanInfo?.checkout?.due_today,
    payFrequency: state.loanInfo?.payFrequency,
    monthlyTotal: state.loanInfo?.checkout?.monthly_total,
    featureGateLinearFlow: state.loanInfo?.featureGateLinearFlow,
    checkout: state?.loanInfo?.checkout,
    vwo: state.technical?.vwo?.decisions?.find(obj => obj.feature === 'checkoutPage')?.variation,
    vwoAll: state.technical?.vwo,
    shopify: state.technical?.shopify,
    offerPageFlow: state.technical?.offerPageFlow,
    confirmedLeaseAgreement: state?.loanInfo?.confirmedLeaseAgreement,
    confirmedPriceTagDisclosure: state?.loanInfo?.confirmedPriceTagDisclosure,
    checkoutLookupData: state.personal?.checkoutLookupData,
    confirmedMyId: state.personal?.newUserDetails?.is_my_id_clicked,
    integrationType: state.technical?.initialize?.integrationType,
    firstName: state.personal?.firstName,
    confirmedAonAgreement: state.loanInfo?.confirmedAonAgreement,
    userId: state.loanInfo?.userId,
    isAonFlow: state.loanInfo?.isAonFlow,
    retailerId: state.technical?.retailerId,
    retailerName: state.technical?.retailerName,
    dueAtCheckout: state.loanInfo?.checkout?.due_at_checkout,
    isInstoreVccFlow: state.technical?.instoreVccFlow?.isInstoreVccFlow,
  }));

  const getPeriod = () => calculatePeriod(store?.checkout?.num_cycles, store?.checkout?.term);

  const isKplusAvailable = checkKplusAvailable(store.checkout);
  const hasProtectionLineItem = isKplusAvailable && !isProtectionDeclined;
  const hasBoostLineItem = Boolean(store.isAonFlow && store.confirmedAonAgreement);
  const kplusMonthlyPrice = isKplusAvailable ? convertToCurrency(store.checkout.kplus_monthly_amount).trim() : '';

  const onMobileSidebarClick = () => {
    setMobileSidebarVisibe(!isMobileSidebarVisibe);
  };

  const removeCoverage = () => {
    setAonModalOpened(true);
  };

  const onAonModalOptOut = async () => {
    setAonModalOpened(false);
    dispatch(confirmAonAgreement(false));
    await apiRequest.updateAonEnrollmentStatus(store.userId, { opted_for_aon_subscription: false });
  };

  const onAonModalClose = () => {
    setAonModalOpened(false);
  };

  const removeProtection = () => {
    setProtectionModalOpened(true);
  };

  const onProtectionModalClose = () => {
    setProtectionModalOpened(false);
  };

  const onProtectionModalOptOut = async () => {
    setProtectionModalOpened(false);
    setKplusUnenrollError('');
    try {
      await apiRequest.unenrollKplus(store.checkoutUid);
    } catch (e) {
      // Keep the coverage row and agreement as-is: the backend still has the customer enrolled.
      setKplusUnenrollError("We couldn't remove Katapult Protection + right now. Please try again.");
      return;
    }
    setIsProtectionDeclined(true);
    dispatch(confirmKplusAgreement(false));
    segmentEvent('track', 'Katapult Protection Plus Declined - ReactSDK', {
      application_id: store.checkoutUid,
      retailer_id: store.retailerId,
      retailer_name: store.retailerName,
      enrollment: 'declined',
      due_at_checkout: store.dueAtCheckout,
    });
  };

  useEffect(() => {
    setTimeout(() => {
      segmentEvent('page', 'Initial Payment', {
        lease_payment: store.monthlyTotal,
        pay_frequency: store.payFrequency,
        // lcr,
        // downpayment
      });
    }, 1000);
  }, []);

  useEffect(() => {
    setValue('terms_agreement', store.confirmedPriceTagDisclosure);
    setValue('lease_agreement', store.confirmedLeaseAgreement);
    setValue('my_id', store.confirmedMyId);
  }, []);

  const onSubmit = async values => {
    setIsSubmitDisabled(true);
    segmentEvent('track', 'Initial Payment Submitted', {
      lease_payment: store.monthlyTotal,
      pay_frequency: store.payFrequency,
    });

    if (store.isAonFlow) {
      segmentEvent('track', 'Katapult Boost Selection Made', {
        retailer_id: store.retailerId,
        retailer_name: store.retailerName,
        enrollment: store.confirmedAonAgreement ? 'accepted' : 'decline',
        due_at_checkout: store.dueAtCheckout,
      });
    }
    // First Payment Submission
    const deviceDataGet = await getUserDeviceData();
    const paymentRequest = await request.paymentRequest(store.checkoutUid, deviceDataGet, {
      ...values,
      CardNumber: cardUnmask(values.CardNumber),
      PaymentType: 'debit',
      Contract: 'true',
      Disclosure: 'true',
    });
    if (paymentRequest) {
      if (window.parent) {
        if (paymentRequest.success === true) {
          if (store.shopify?.isShopify) {
            const resolveResult = await shopifyRequest.resolveRequest({
              transaction_id: store.shopify?.transactionId,
              uid: store.checkoutUid,
            });
            dispatch(addResolveRedirectUrl(resolveResult?.context?.redirectUrl));
            history.push('/after-payment');
            return;
          }
          if (store.isInstoreVccFlow) {
            history.push('/katapult-pay-card');
            return;
          }
          if (store.integrationType) {
            history.push('/check-lease');
            return;
          }
          setIsPaymentFailed(false);
          setMessagePaymentError('');
          // First Payment Success
          segmentEvent('track', 'Initial Payment Successful', {
            lease_payment: store.monthlyTotal,
            pay_frequency: store.payFrequency,
          });
          if (store.offerPageFlow?.afterPaymentPage) {
            history.push('/after-payment');
            return;
          }
          const payload = JSON.parse(
            JSON.stringify({ katapultSDK: 'payment-success', payload: { paymentToken: store.checkoutUid } }),
          );
          window.parent.postMessage(payload, '*');
        } else {
          setIsSubmitDisabled(false);
          setIsPaymentFailed(true);
          segmentEvent('track', 'Initial Payment Failed', {
            lease_payment: store.monthlyTotal,
            pay_frequency: store.payFrequency,
            Reason: paymentRequest?.error?.Reason,
          });
          setMessagePaymentError(
            paymentRequest?.error?.Reason ||
              `Unfortunately we're unable to process your transaction due to a problem with your payment method.
              Please try a different payment method.`,
          );
        }
      }
    } else {
      // First Payment Decline
      setIsSubmitDisabled(false);
      segmentEvent('track', 'Initial Payment Failed', {
        lease_payment: store.monthlyTotal,
        pay_frequency: store.payFrequency,
      });
    }
  };

  const protectionRemoveButton = (
    <button type="button" className="k-checkout-summary__remove" onClick={removeProtection}>
      Remove
    </button>
  );
  const boostRemoveButton = (
    <button type="button" className="k-checkout-summary__remove" onClick={removeCoverage}>
      Remove
    </button>
  );

  return (
    <div className="k-content-wrapper">
      {isPaymentFailed && (
        <section>
          <div className="k-warning-section">{messagePaymentError}</div>
        </section>
      )}

      {store.vwo === 'Version-A' && (store.shopify?.isShopify || store.isInstoreVccFlow) && (
        <section className="k-checkout-mobile-sidebar">
          <div
            className={`k-checkout-mobile-sidebar-text ${isMobileSidebarVisibe ? 'k-mobile-sidebar-opened' : ''}`}
            role="button"
            onClick={onMobileSidebarClick}
            onKeyDown={onMobileSidebarClick}
            tabIndex={0}
          >
            {isMobileSidebarVisibe ? 'Back to checkout' : 'Tap to view lease overview'}
          </div>
          {isMobileSidebarVisibe && (
            <div className="k-checkout-mobile-sidebar-content">
              <SidebarCheckout data={store.checkout} checkout={store.checkoutLookupData} firstname={store.firstName} />
            </div>
          )}
        </section>
      )}
      {store.vwo !== 'Version-B' && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <section className="k-info">
            <h1 className="k-h1-large" style={{ marginBottom: '12px' }}>
              Enter your payment method
            </h1>
          </section>
          <section className="k-form" style={{ marginTop: '26px', marginBottom: '50px' }}>
            <div className="k-checkout-card-box">
              <div className="k-field animate__animated animate__fadeInDown">
                <div className="k-checkout-card-box__label-row">
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label htmlFor="CardNumber">Card Number</label>
                  <img src={Cards} alt="" className="k-checkout-card-box__brand-icons" />
                </div>
                <input
                  placeholder="1234 5678 9012 3456"
                  type="tel"
                  inputMode="numeric"
                  autoComplete="cc-number"
                  name="CardNumber"
                  id="CardNumber"
                  className="cardNumber"
                  onChange={e => {
                    const { value } = e.target;
                    e.target.value = normalizeCardNumber(value);
                    CardNumber.onChange(e);
                  }}
                  onBlur={CardNumber.onBlur}
                  ref={CardNumber.ref}
                />
                <div className="k-form-validation-message">
                  <ErrorMessage errors={errors} name="CardNumber" message="Don't forget this field" />
                </div>
              </div>
              <div className="two-column">
                <div className="k-field animate__animated animate__fadeInDown">
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label htmlFor="CardExpiration" className="k-labels-checkout-same-size">
                    Expiry Date
                  </label>
                  <input
                    placeholder="MM / YY"
                    type="tel"
                    inputMode="numeric"
                    name="CardExpiration"
                    id="CardExpiration"
                    className="fs-mask"
                    maxLength="5"
                    onChange={e => {
                      CardExpiration.onChange(e);
                      const { value } = e.target;
                      e.target.value = normalizeCardDate(value);
                    }}
                    onBlur={CardExpiration.onBlur}
                    ref={CardExpiration.ref}
                  />
                  <div className="k-form-validation-message">
                    <ErrorMessage errors={errors} name="CardExpiration" render={({ message }) => message} />
                  </div>
                </div>
                <div className="k-field animate__animated animate__fadeInDown">
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label htmlFor="CardCvv" className="k-labels-checkout-same-size">
                    Security Code
                  </label>
                  <input
                    placeholder="CVV"
                    type="tel"
                    inputMode="numeric"
                    name="CardCvv"
                    id="CardCvv"
                    className="fs-mask"
                    maxLength="4"
                    {...register('CardCvv', {
                      required: "Don't forget this field",
                      minLength: 3,
                    })}
                  />
                  <div className="k-form-validation-message">
                    <ErrorMessage errors={errors} name="CardCvv" message="Don't forget this field" />
                  </div>
                </div>
              </div>
              <div className="k-checkout-card-box__secure-note">
                <img src={Lock} alt="" className="k-checkout-card-box__lock-icon" /> Your card information is encrypted
                and secure.
              </div>
            </div>
            <section className="k-checkout-summary">
              <LineItemRow label="Due today" value={convertToCurrency(store.dueToday) || '$0.00'} />
              <LineItemRow
                label="Recurring lease payment"
                value={`${(convertToCurrency(store?.checkout?.monthly_total) || '$0.00').trim()}/${
                  getPeriod() || store.payFrequency || 'weekly'
                }`}
              />
              {hasProtectionLineItem && (
                <LineItemRow
                  label="Katapult Protection +"
                  value={`${kplusMonthlyPrice}/month`}
                  action={protectionRemoveButton}
                />
              )}
              {kplusUnenrollError && !isProtectionDeclined && (
                <div className="k-warning-section" role="alert">
                  {kplusUnenrollError}
                </div>
              )}
              {hasBoostLineItem && (
                <LineItemRow
                  label="Katapult Boost"
                  value={`${KATAPULT_BOOST_PRICE}/month`}
                  action={boostRemoveButton}
                />
              )}
            </section>
            <div className="k-checkout-disclaimer">
              <img src={InfoIcon} alt="" className="k-checkout-disclaimer__icon" />
              <span>
                This card will be used for today&apos;s payment and all future payments.
                {hasProtectionLineItem || hasBoostLineItem ? (
                  <> Lease and membership charges will be billed separately.</>
                ) : null}
              </span>
            </div>
            <SubmitButton
              disabled={isSubmitDisabled}
              grey={!isValid}
              text="MAKE PAYMENT"
              loading={loading || shopifyLoading}
            />
          </section>
        </form>
      )}

      {store.vwo === 'Version-B' && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <section className="k-info">
            <h1 className="k-info-vwo-header" style={{ marginBottom: '12px' }}>
              Please provide a payment method below!
            </h1>
          </section>
          <section className="k-info">
            <div className="k-info-vwo-due">
              <div>
                Due today
                <TooltipDueToday
                  title={null}
                  data={{
                    initialPayment: store?.checkout?.initial_payment,
                    processingFee: store?.checkout?.processing_fee,
                    shipping: store?.checkout?.shipping,
                    nonLesableItems: store?.checkout?.non_leasable_item_amount,
                    tax: store?.checkout?.tax_due_checkout,
                    total: store?.checkout?.due_today,
                    duePeriodPayment: store?.checkout?.monthly_total,
                    payFrequency: store.payFrequency,
                  }}
                  classNameAdded="k-info-vwo-tooltip"
                />
              </div>
              <div>{convertToCurrency(store.dueToday)}</div>
            </div>
            <p className="k-info-vwo-details">
              We will charge this same payment method for all future lease payments as they become due. You can change
              your payment method anytime. You can also return your items within the return policy for a full refund.
            </p>
          </section>
          <section className="k-form" style={{ marginTop: '26px', marginBottom: '50px' }}>
            <div className="k-field animate__animated animate__fadeInDown">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="CardNumber" className="k-info-vwo-cards">
                <div>Card Number</div>
                <div className="k-info-vwo-elements">
                  <img width="50" height="25" src={Card1} alt="" className="k-info-vwo-element" />
                  <img width="50" height="25" src={Card2} alt="" className="k-info-vwo-element" />
                  <img width="50" height="25" src={Card3} alt="" className="k-info-vwo-element" />
                  <img width="50" height="25" src={Card4} alt="" className="k-info-vwo-element" />
                </div>
              </label>
              <div className="k-info-vwo-input-container">
                <input
                  placeholder="XXXX XXXX XXXX XXXX"
                  type="tel"
                  inputMode="numeric"
                  autoComplete="cc-number"
                  name="CardNumber"
                  id="CardNumber"
                  className="cardNumber k-info-vwo-cardNumber"
                  onChange={e => {
                    const { value } = e.target;
                    e.target.value = normalizeCardNumber(value);
                    CardNumber.onChange(e);
                  }}
                  onBlur={CardNumber.onBlur}
                  ref={CardNumber.ref}
                />
                <img src={Lock} alt="" className="k-info-vwo-input-image" />
              </div>

              <div className="k-form-validation-message">
                <ErrorMessage errors={errors} name="CardNumber" message="Don't forget this field" />
              </div>
            </div>
            <div className="two-column">
              <div className="k-field animate__animated animate__fadeInDown">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="CardExpiration" className="k-labels-checkout-same-size k-info-vwo-label">
                  Expiration date
                </label>
                <input
                  placeholder="MM/YY"
                  type="tel"
                  inputMode="numeric"
                  name="CardExpiration"
                  id="CardExpiration"
                  className="fs-mask"
                  maxLength="5"
                  onChange={e => {
                    CardExpiration.onChange(e);
                    const { value } = e.target;
                    e.target.value = normalizeCardDate(value);
                  }}
                  onBlur={CardExpiration.onBlur}
                  ref={CardExpiration.ref}
                />
                <div className="k-form-validation-message">
                  <ErrorMessage errors={errors} name="CardExpiration" render={({ message }) => message} />
                </div>
              </div>
              <div className="k-field animate__animated animate__fadeInDown">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="CardCvv" className="k-labels-checkout-same-size k-info-vwo-label">
                  Security code
                </label>
                <div>
                  <input
                    placeholder="CVC"
                    type="tel"
                    inputMode="numeric"
                    name="CardCvv"
                    id="CardCvv"
                    className="fs-mask k-info-vwo-cardNumber"
                    maxLength="4"
                    {...register('CardCvv', {
                      required: "Don't forget this field",
                      minLength: 3,
                    })}
                  />
                  <img src={Lock} alt="" className="k-info-vwo-input-image-cvv" />
                </div>
                <div className="k-form-validation-message">
                  <ErrorMessage errors={errors} name="CardCvv" message="Don't forget this field" />
                </div>
              </div>
            </div>
            <SubmitButton
              disabled={isSubmitDisabled}
              grey={!isValid}
              classNameAdded="k-info-vwo-submit-button"
              text={`MAKE PAYMENT OF ${convertToCurrency(store.dueToday) || '$0.00'}`}
              loading={loading}
            />
          </section>
        </form>
      )}
      {isAonModalOpened && (
        <div className="plugin-aon-modal">
          <div className="plugin-aon-modal-overlay">
            <div className="plugin-aon-modal-content">
              <div className="plugin-aon-modal-cross">
                <div
                  className="plugin-aon-modal-close"
                  onClick={onAonModalClose}
                  onKeyPress={onAonModalClose}
                  role="button"
                  tabIndex={0}
                  aria-label="Close modal"
                >
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.5 12.5L2.5 2.5M12.5 2.5L2.5 12.5"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>
              <div className="plugin-aon-modal-header">
                Are you sure you want to opt out of Katapult Boost coverage?
              </div>
              <div className="plugin-aon-modal-text">You&apos;ll lose access to protection benefits and discounts.</div>
              <div className="k-submit plugin-aon-modal-buttons">
                <button
                  type="button"
                  className="button vibrant plugin-aon-modal-buttons-main"
                  onClick={onAonModalClose}
                >
                  Keep coverage
                </button>
                <button
                  type="button"
                  className="secondary-button plugin-aon-modal-buttons-secondary"
                  onClick={onAonModalOptOut}
                >
                  Decline coverage
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isProtectionModalOpened && (
        <div className="plugin-aon-modal plugin-aon-modal--protection">
          <div className="plugin-aon-modal-overlay">
            <div className="plugin-aon-modal-content">
              <div className="plugin-aon-modal-cross">
                <div
                  className="plugin-aon-modal-close"
                  onClick={onProtectionModalClose}
                  onKeyPress={onProtectionModalClose}
                  role="button"
                  tabIndex={0}
                  aria-label="Close modal"
                >
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.5 12.5L2.5 2.5M12.5 2.5L2.5 12.5"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              </div>
              <div className="plugin-aon-modal-header">Are you sure you want to skip Katapult Protection +?</div>
              <div className="plugin-aon-modal-text">
                Without it, you&apos;re responsible for paying the fair market value of your leased item if it is stolen
                or damaged beyond repair by a natural disaster. KP + Protection helps you stay covered and keeps your
                progress toward ownership.
              </div>
              <div className="k-submit plugin-aon-modal-buttons">
                <button
                  type="button"
                  className="button vibrant plugin-aon-modal-buttons-main"
                  onClick={onProtectionModalClose}
                >
                  Keep coverage
                </button>
                <button
                  type="button"
                  className="secondary-button plugin-aon-modal-buttons-secondary"
                  onClick={onProtectionModalOptOut}
                >
                  Decline coverage
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Checkout;
